module.exports={common:{app_name:"Espoon digivastaanotto",app_organization:"Espoon kaupunki"},intro:{title:"Tervetuloa Espoon Digivastaanotolle"}};